import React from "react";
import { showFormattedDate } from "../../../../../../Utils";
import { UNKNOWN_AUTHORIZATION_DATE } from "../../config";

export function Authorize({ authorizedOn, onAuthorize }) {
  return (
    <div className="row">
      <div className="col-xs-12">
        {!authorizedOn && (
          <button
            className="new-blue-btn pull-left m-l-0 m-b-10"
            onClick={onAuthorize}
          >
            Authorize
          </button>
        )}
        {authorizedOn && (
          <p className="AuthorizedSync">
            <i className="fa fa-check-circle"></i>{" "}
            {authorizedOn === UNKNOWN_AUTHORIZATION_DATE
              ? "Authorized"
              : "Authorized on" + " " + showFormattedDate(authorizedOn, true)}
          </p>
        )}
      </div>
    </div>
  );
}
